/**
 * Asserts to Typescript that a given property exists on an object.
 * In some cases, the second of these two examples will throw a compiler error, even though it's technically a "safe" operation.
 * Warning, this does _not_ technically check the property is truthy, just that the object has the property.
 * @example if (isPropertyOf("a", obj)) ? obj[a] : "fallback";
 * @example return obj[a] ?? "fallback";
 */
export const isPropertyOf = <T extends Record<string, unknown>>(
  obj: T,
  potentialKey: string
): potentialKey is keyof T & string => {
  return Object.hasOwn(obj, potentialKey);
};
